/** @format */

import { cdrConstants } from './actions';
import { reducerDebug } from '../../core/debug';

export type CdrReducers = {
    type: string;
    collections: any;
};

export function cdrReducers(state = {}, action: CdrReducers): object {
    reducerDebug('Cdrs reducer: ' + action.type);
    switch (action.type) {
        case cdrConstants.LIST:
            return {
                ...state,
                type: action.type,
                collections: action.collections,
            };
        default:
            return {
                ...state,
            };
    }
}
